import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { withRouter } from 'react-router'
import { Field } from 'redux-form';
import { Row, Col} from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import { Translate } from 'react-redux-i18n';

class AdjustInventoryForm extends Component {

    handleFormSubmit = (formProps) => {
      const props = {...formProps, ReasonDesc: formProps.ReasonDesc};
      if (this.props.reason) {
        const id = this.props.reason.id;
        this.props.editReason(props, id);
      } else {
        this.props.createReason(props);
      }
    }

    renderForm() {
      const { detailError, detailIsLoading } = this.props;
      if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
      else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
      return (
        <Row>
          <Row>
            <Col sm={1} />
            <Col sm={4}>
              <div className="form-group">
                <label><em className="fa fa-building-o marginRightStyle" />| <Translate value="reason" /> (*) </label>
                <Row><Col sm={12}><Field name="ReasonDesc" component={InputField} placeholder="Reason" /></Col></Row>
              </div>
            </Col>
          </Row>
        </Row>
      );
    }

    render() {
      const { handleSubmit, submitting, pristine, valid, closeG, } = this.props;
      return (
        <ContentWrapper>
          <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
            <br />
            <div className="pull-right">
              { this.props.isCreating || this.props.isEditing && <Spinner/> }
              <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="save" /></button>
              <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>
            </div>
            {this.renderForm() }
          </form>
        </ContentWrapper>
      );
    }
}

export default withRouter(AdjustInventoryForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/adjustInventoryForm.jsx